import styled from '@emotion/styled'

export const TooltipChildWrapper = styled.div`
  display: flex;
  align-items: center;
  width: min-content;
`
